import { render, staticRenderFns } from "./word-usage-examples.vue?vue&type=template&id=133b475f&"
import script from "./word-usage-examples.vue?vue&type=script&lang=js&"
export * from "./word-usage-examples.vue?vue&type=script&lang=js&"
import style0 from "./word-usage-examples.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('133b475f', component.options)
    } else {
      api.reload('133b475f', component.options)
    }
    module.hot.accept("./word-usage-examples.vue?vue&type=template&id=133b475f&", function () {
      api.rerender('133b475f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-usage-examples/word-usage-examples.vue"
export default component.exports